import Content from "uxp-documentation/src/pages/uxp-api/reference-js/Modules/uxp/Entry Points/EntryPointsError";
import * as React from 'react';
export default {
  Content,
  React
};